import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export enum ChecklistItemStatus {
	unknown,
	pass,
	fail,
	notApplicable
}

export interface IInspectionChecklistItem extends IModel {
	name?: string;
	value?: string;
	siteVisitKey?: string;
	status?: ChecklistItemStatus
	workAreaKey?: string;
}

const siteVisitChecklistItemFactory = modelFactory.createFactory<IInspectionChecklistItem>('InspectionChecklistItem', _.assign({}, model, {
	name: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string(true)
	},
	siteVisitKey: {
		setFilters: valueFilters.toString,
		rules: validator.string(true)
	},
	status: {
		setFilters: valueFilters.toNumber,
		rules: validator.number()
	},
	workAreaKey: {
		setFilters: valueFilters.toString,
		rules: validator.string(true)
	},
}));

export default siteVisitChecklistItemFactory;